import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const getApproverMatrixData = async (input) => {
     InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "APPR_MATRIX_GET";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

const result = await GatewayGet(props, props.input);
    return result;
  };

  export const getApproverData = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "APPR_GET_LIST";
   inputObj["Input"] = InputJSONString;
   
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 };

 export const updateApproverData = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "APPR_MATRIX_UPD";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 };

 export const getAuthList = async (input) => {
   InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "AUTH_GET_LIST";
  inputObj["Input"] = InputJSONString;
  props.input = inputObj;

const result = await GatewayGet(props, props.input);
  return result;
};

 export const getSegments = async () => {
    // InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "F4_WF_SEGMENTS";
    inputObj["Input"] = "";
    props.input = inputObj;

const result = await GatewayGet(props, props.input);
    return result;
  };

  export const getApproverSegments = async () => {
   // InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "APPR_SEGMENT_LIST";
   inputObj["Input"] = "";
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 };

 export const DeleteApproverData = async (input) => {
   InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "APPR_MATRIX_DEL";
  inputObj["Input"] = InputJSONString;
  props.input = inputObj;

const result = await GatewayGet(props, props.input);
  return result;
};







